export const STATUS_WAITING_FOR_OFFER = 'WAITING_FOR_OFFER'
export const STATUS_UNDER_NEGOTIATION = 'UNDER_NEGOTIATING'
export const STATUS_READY_TO_PAIR = 'READY_TO_PAIR'
export const STATUS_OFFER_DENIED = 'OFFER_DENIED'
export const STATUS_OFFER_DECLINED = 'OFFER_DECLINED'
export const STATUS_CANCELLED = 'CANCELLED'
export const STATUS_DELETED = 'DELETED'
export const STATUS_UNAVAILABLE = 'UNAVAILABLE'
export const STATUS_EXPIRED = 'EXPIRED'
export const STATUS_IN_QA_CHECK = 'IN_QA_CHECK'

export const OFFER_STATUS_WAITING_COUNTER_PART = 'WAITING_COUNTER_PART'
export const OFFER_STATUS_WAITING_VERIFICATION = 'WAITING_VERIFICATION'
export const OFFER_STATUS_PASSED = 'PASSED'
export const OFFER_STATUS_CLOSED = 'OFFER_CLOSED'
export const OFFER_STATUS_WAITING = 'WAITING'

export const TRANSACTION_TYPE_LOAD = 'LOAD'
export const TRANSACTION_TYPE_TRUCK = 'TRUCK'
export const TRANSACTION_TYPE_MATCHED = 'MATCHED'

export const SUB_STATUS_WAITING_FOR_YOU = 'WAITING_FOR_YOU'

export const INPUT_CHARACTER_LIMITS = {
  PLATES: 225,
  VAT_ID: 12,
  INVOICE_NO: 25,
  SALES_INVOICE_NO: 12,
  CREDIT_NOTE_NO: 12,
  ORDER_NO: 8,
  CUSTOMER_REF_NO: 100,
  CUSTOMER_REF_NO_COMBINED: 100,
  CONTACT_NO: 20,
  EMAIL: 64,
  POSTAL_CODE: 10,
  PRICE: 10,
  COMPANY_NAME: 128,
  USER_NAME: 64,
  LOCATION: 128,
  INTERNAL_COMMENT: 512,
  ADDITIONAL_INFO: 512
}

export const TENNDERS_VAT_ID = 'ESB42908657'

export const loadTypes = (t) => [
  {
    label: t('variables:FTL'),
    value: 1
  },
  {
    label: t('variables:LTL'),
    value: 2
  }
]
